import { render, staticRenderFns } from "./DefaultRouteNavItem.vue?vue&type=template&id=327e93fa&scoped=true"
import script from "./DefaultRouteNavItem.vue?vue&type=script&lang=ts"
export * from "./DefaultRouteNavItem.vue?vue&type=script&lang=ts"
import style0 from "./DefaultRouteNavItem.vue?vue&type=style&index=0&id=327e93fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e93fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327e93fa')) {
      api.createRecord('327e93fa', component.options)
    } else {
      api.reload('327e93fa', component.options)
    }
    module.hot.accept("./DefaultRouteNavItem.vue?vue&type=template&id=327e93fa&scoped=true", function () {
      api.rerender('327e93fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DefaultRouteNavItem.vue"
export default component.exports